import createVpn from './actions/createVpn';
import getVpn from './actions/getVpn';
import updateVpn from './actions/updateVpn';
import vpnRemove from './actions/vpnRemove';
import vpnsList from './actions/vpnsList';
import getVPNs from './getters/getVPNs';
import uploadVPNs from './mutations/uploadVPNs';

const actions = {
    createVpn,
    updateVpn,
    getVpn,
    vpnsList,
    vpnRemove,
};

const mutations = {
    uploadVPNs
};

const getters = {
    getVPNs
};

export default { actions, mutations, getters };
